export const REQUEST_TOOLBAR_NOTIFICATIONS = "REQUEST_TOOLBAR_NOTIFICATIONS";
export const REQUEST_TOOLBAR_NOTIFICATIONS_DONE =
  "REQUEST_TOOLBAR_NOTIFICATIONS_DONE";

export interface FetchToolbarNotifications {
  type: typeof REQUEST_TOOLBAR_NOTIFICATIONS;
  payload: any[];
}

export interface FetchToolbarNotificationsDone {
  type: typeof REQUEST_TOOLBAR_NOTIFICATIONS_DONE;
  payload: any[];
}

export interface ToolbarNotificationsState {
  isLoading: boolean;
  toolbarNotifications: any[];
}

export type ToolbarNotificationsActions =
  | FetchToolbarNotifications
  | FetchToolbarNotificationsDone;
